<template>
<v-container fluid>
    <v-card class="ma-2" outlined>
        <v-card-title>
            <v-btn icon @click="goToUserList()">
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            {{ userName }}
        </v-card-title>
        <v-timeline v-if="itemList[0]">
            <v-timeline-item v-for="item in itemList" :key="item.id" :userAvatar="userAvatar" small>
                <template v-slot:icon>
                    <v-avatar v-if="userAvatar">
                        <img :src="userAvatar" />
                    </v-avatar>
                    <v-avatar v-else color="info">
                        <v-icon dark> mdi-account-circle </v-icon>
                    </v-avatar>
                </template>
                <template v-slot:opposite>
                    <p>{{ item.title }}</p>
                    <p>{{ _formatData("datetime", item.date) }}</p>
                </template>
                <v-card class="mx-auto" max-width="400">
                    <v-img class="white--text align-end" height="100%" :src="item.imageUrl">
                    </v-img>
                    <v-card-text class="text--primary">
                        <div>{{ item.note }}</div>
                    </v-card-text>
                </v-card>
            </v-timeline-item>
        </v-timeline>
        <v-timeline v-else>
            <v-timeline-item small>
                <template v-slot:icon>
                    <v-avatar v-if="userAvatar">
                        <img :src="userAvatar" />
                    </v-avatar>
                    <v-avatar v-else color="info">
                        <v-icon dark> mdi-account-circle </v-icon>
                    </v-avatar>
                </template>
                <template v-slot:opposite>
                    <p>No image</p>
                </template>
            </v-timeline-item>
        </v-timeline>
    </v-card>
</v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import formatData from "../utils/formatData";
import getMediaAttached from "../data/getMediaAttached";
import getUserInfoByUserId from "../data/getUserInfoByUserId";
export default {
    name: 'ChallengeUser',
    metaInfo: {
        title: 'Challenge User'
    },
    data() {
        return {
            userName: "",
            userAvatar: "",
            itemList: [],
            loading: false
        };
    },
    created() {
        var vm = this;
        vm.$store.state.appTitle = "Thaisook Web Admin | Challenge";
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                vm.$store.dispatch("autoSignIn", user);
                this.loading = true;
                setTimeout(() => {
                    vm.initialize();
                }, "1000");
            } else {
                console.log("no user");
            }
        });
        // this.user = this.$store.state.user;
        // this.initialize();
        this.id = this.$route.params.id;
        this.group_id = this.$route.params.group_id;
        this.user_id = this.$route.params.user_id;
    },
    methods: {
        initialize() {
            if (this.isSuperAdmin || this.isChallengeAdmin) {
                (async () => {
                    this.loading = true;
                    this.itemList = await getMediaAttached(this.id, this.user_id);
                    this.loading = false;
                })();

                (async () => {
                    this.loading = true;
                    const userInfo = await getUserInfoByUserId(this.user_id);
                    this.userName = userInfo.firstname + " " + userInfo.lastname;
                    this.userAvatar = userInfo.avatar;
                    this.loading = false;
                })();
            } else {
                this.$router.push(`/dashboard`);
            }
        },
        _formatData(type, value) {
            return formatData(type, value);
        },
        goToGroupList() {
            this.$router.push(`/challenge/${this.id}`);
        },
        goToUserList() {
            this.$router.push(`/challenge/${this.id}/${this.group_id}`);
        },
    },
};
</script>